import { render } from "./NavigationBar.vue?vue&type=template&id=e54fff7c"
const script = {}

import "./NavigationBar.vue?vue&type=style&index=0&id=e54fff7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__